import styled from 'styled-components';
import { Typography } from 'components/ui';
import theme from 'theme';

export const Footer = styled.footer`
  text-align: center;
  background-color: ${theme.palette.primary.gray};
  padding: ${theme.padding.footer};
`;

export const FooterTitle = styled(Typography)`
  font-size: ${theme.typography.fontSizeBig}px;
  font-weight: bold;
  margin-bottom: ${theme.padding.section};
`;

export const FooterText = styled(Typography)`
  font-size: ${theme.typography.fontSize}px;
  color: ${theme.palette.text.secondary};
`;
export const FooterDescription = styled(Typography)`
  font-size: ${theme.typography.fontSizeSmall}px;
  color: ${theme.palette.text.secondary};
`;
